import React, {createContext, useEffect, useRef, useState} from 'react';
import ReactGA from 'react-ga';
import {useSelector, useDispatch} from 'react-redux';
import Masthead from './containers/Masthead';
import WordsPanel from './containers/WordsPanel';
import Board from './containers/Board';
import {ANSWERING_GAME_MODE, GAME_COMPLETED_MODE, GAME_TIME_UP_MODE, IDLE_GAME_MODE} from './constants';
import LetterBox from './components/LetterBox';
import {
    enterIdleMode,
    cancelConfirmation,
    confirmPendingAction,
    enterGameCompletedMode,
    enterGameTimeUpMode,
} from './actions/actions';
import Backdrop from './components/Backdrop';
import ConfirmationModal from './components/ConfirmationModal';
import './App.scss';
import IntroModal from './components/IntroModal';
import WordSearchGameState from './mobx/WordSearchGameState';
import GameOver from './components/GameOver';
import {observer} from 'mobx-react';
import {autorun} from 'mobx';
import TimeUp from './components/TimeUp';

const wordSearchGameState = new WordSearchGameState();
export const StateContext = createContext();

const TRACKING_ID = 'UA-222727127-1';
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

// Disable the context menu
window.oncontextmenu = function () {
    return false;
};

const App = observer(() => {
    const gameMode = useSelector((state) => state.gameMode);
    const collectedLetters = useSelector((state) => state.collectedLetters);
    const pendingConfirmation = useSelector((state) => state.pendingConfirmation);
    const [showIntro, setShowIntro] = useState(true);
    const dispatch = useDispatch();
    const [showGameOver, setShowGameOver] = useState(false);

    function onMouseUp(event) {
        if (gameMode === ANSWERING_GAME_MODE) {
            // Return to idle mode
            dispatch(enterIdleMode());
        }
    }

    function onCancelConfirmation() {
        dispatch(cancelConfirmation());
    }

    function onConfirmPendingAction() {
        dispatch(confirmPendingAction());
    }

    function onIntroClose() {
        ReactGA.event({
            category: 'User',
            action: 'Start Playing',
        });
        setShowIntro(false);
        wordSearchGameState.startTimer();
    }

    useEffect(() => {
        wordSearchGameState.setNewLevel(localStorage.getItem('level'));
        autorun(() => {
            if (wordSearchGameState.timer.seconds === 0) {
                ReactGA.event({
                    category: 'Game',
                    action: 'Time Is Up',
                });
                wordSearchGameState.pauseTimer();
                dispatch(enterGameTimeUpMode());
            }
        });
    }, []);

    useEffect(() => {
        if (gameMode === IDLE_GAME_MODE) {
            setShowGameOver(false);
        }

        if (gameMode === GAME_COMPLETED_MODE) {
            setTimeout(() => {
                setShowGameOver(true);
            }, 2300);
        }
    }, [gameMode, collectedLetters]);

    return (
        <StateContext.Provider value={wordSearchGameState}>
            <div className="App noselect" onMouseUp={onMouseUp}>
                <Masthead />
                {showGameOver ? (
                    <GameOver />
                ) : gameMode === GAME_TIME_UP_MODE ? (
                    <TimeUp />
                ) : (
                    <>
                        <WordsPanel />
                        <Board />
                    </>
                )}

                {(pendingConfirmation || showIntro) && <Backdrop />}
                {pendingConfirmation && (
                    <ConfirmationModal onConfirm={onConfirmPendingAction} onCancel={onCancelConfirmation}>
                        {pendingConfirmation.msg}
                    </ConfirmationModal>
                )}

                {showIntro && <IntroModal onClose={onIntroClose}></IntroModal>}
                <div align="right" className="footer">
                    Matti Bar-Zeev, 2022
                </div>
            </div>
        </StateContext.Provider>
    );
});

export default App;
